import { IPendingPayment } from "interfaces";
import { abbreviateNumbers, currencySymbol, formatNumber, getPaymentMethodLabel } from "utills/helpers";

interface PendingPaymentTableProps {
  data?: IPendingPayment[];
  isLoading: boolean;
}

export const PendingPaymentTable = ({data = [], isLoading }: PendingPaymentTableProps) => {  
  return (
    <div className="flow-root">
      <div className="relative inline-block w-full align-middle box-border">
        <table className="w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
          <thead>
            <tr>
              <th
                scope="col"
                className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8"
              >
                No
              </th>
              <th scope="col" className="th">
                Payment method
              </th>
              <th scope="col" className="th">
                Total orders
              </th>
              <th scope="col" className="th">
                Gross revenue
              </th>
              <th scope="col" className="th">
                Net revenue
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
          {(!isLoading) ? data.map((item: IPendingPayment, index: number) => (
              <tr key={index}>
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  {index + 1}
                </td>
                <td className="td max-w-10 overflow-x-auto">
                  {getPaymentMethodLabel(item.payment_method)}
                </td>
                <td className="td overflow-x-auto">
                  <span
                    data-tooltip-id="tooltip"
                    data-tooltip-content={formatNumber(item.total_order)}
                  >
                    {abbreviateNumbers(item.total_order)}
                  </span>
                </td>
                <td className="td overflow-x-auto">
                  <span
                    data-tooltip-id="tooltip"
                    data-tooltip-content={formatNumber(item.gross_revenue)}
                  >
                    {currencySymbol()} {abbreviateNumbers(item.gross_revenue)}
                  </span>
                </td>
                <td className="td overflow-x-auto">
                  <span
                    data-tooltip-id="tooltip"
                    data-tooltip-content={formatNumber(item.net_revenue)}
                  >
                    {currencySymbol()} {abbreviateNumbers(item.net_revenue)}
                  </span>
                </td>
              </tr>
            )) 
            : Array(10).fill(null).map((item: any, index: number) => (
              <tr key={index} className="h-[57px]">
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td max-w-40 overflow-x-auto">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
              </tr>
            ))}
            {data.length === 0 && !isLoading ? (
              <tr>
                <td colSpan={10} className="td">
                  <div className="text-center">
                    No data
                  </div>
                </td>
              </tr>
            ) : <></>}
          </tbody>
        </table>
      </div>

    </div>

  )
}